import React from 'react';

const CollaborationAgreementTemplate = () => {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <p>
          <u>Opgelet: dit is een template. Update-pro bezorgt jou een officiële overeenkomst</u>
        </p>
      </div>

      <p>
        Overeenkomst tussen <strong>Update-pro BVBA</strong> en <strong>{`{BedrijfsnaamBedrijfsnaam}`}</strong> met
        betrekking tot het ter beschikking stellen van uitzendkrachten.
      </p>

      <p>Tussen</p>

      <h3>Update-pro BVBA</h3>

      <p>hierbij rechtsgeldig vertegenwoordigd door mevrouw Dominique Matheussen, zaakvoerder,</p>

      <p>hierna genoemd „Update-pro”</p>

      <p>
        en <strong>{`{BedrijfsnaamBedrijfsnaam}`}</strong>
      </p>

      <p>
        Adres hoofdzetelAdres hoofdzetel , Postcode + gemeente hoofdzetelPostcode + gemeente hoofdzetel
        {`     { Bedrijfsnaam BTW nummer}`}
      </p>

      <p>
        Nr. paritair comité: : ...... voor arbeiders
        <br />
        Nr. paritair comité: .......... voor bedienden
      </p>

      <p>
        hierbij rechtsgeldig vertegenwoordigd door de gebruikerde gebruikerde gebruiker , hierna genoemd „de gebruiker”
      </p>

      <p>
        De gebruiker geeft online de basisgegevens door van het bedrijf en van de tijdelijke medewerker samen met een
        kopij van het identiteitsbewijs en/of verblijfsdocumenten en arbeidskaart. Hierdoor bevestigt de gebruiker dat
        de uitzendkracht die bij hem tewerkgesteld wordt daadwerkelijk de persoon is die via Update-pro onder contract
        wordt gezet. Met de uitzendkracht maakt de gebruiker goede afspraken over het loon en de bijkomende voordelen.
        De gebruiker laat steeds schriftelijk aan Update-pro weten wanneer en waar er gewerkt wordt. Update-pro maakt de
        nodige contracten en documenten in orde. Automatisch worden de nodige aanmeldingen gedaan. Op het einde van de
        week/maand/werkperiode vult de gebruiker de prestatiestaten van de uitzendkracht(en) in. Update-pro betaalt het
        loon en alle afgesproken voordelen (maaltijd- en ecocheques, vergoeding 0woon-werkverkeer, …) In geval de
        gebruiker andere voordelen toekent in de zin van forfaitaire onkostenvergoedingen kan Update-pro enkel deze
        betalen indien ze in het bezit is van de nodige bewijsstukken (geen e-mail). Wanneer de werkperiode er op zit,
        verwittigt de gebruiker Update-pro en zorgen wij voor de nodige documenten en afmeldingen bij de benodigde
        instanties. De uitzendkracht(en) is volledig in orde en verzekerd in geval van een arbeidsongeval/ weg-
        werkongeval. Reden voor de terbeschikkingstelling van uitzendkrachten
        <br />
        Onder de huidige overeenkomst kunnen volgende redenen voor de terbeschikkingstelling van uitzendkrachten worden
        ingeroepen:
        <ol>
          <li>de vervanging van een vaste werknemer van wie de arbeidsovereenkomst is geschorst.</li>
          <li>de vervanging van een vaste werknemer van wie de arbeidsovereenkomst is beëindigd.</li>
          <li>tijdelijke vermeerdering van werk</li>
          <li>uitzonderlijk werk</li>
          <li>instroom</li>
        </ol>
        De reden wordt bepaald bij iedere tewerkstelling afzonderlijk en wordt vermeld op de uitzendkrachtcontracten.
      </p>

      <h3>2.1 Prijsvoorstel</h3>
      <p>Functie - Payroll Update-pro</p>
      <ul>
        <li>
          Arbeider: <strong>{`{Coeff ARB}`}</strong>
        </li>
        <li>
          Bediende: <strong>{`{Coeff BED}}`}</strong>
        </li>
        <li>
          Student (475-uren regeling): <strong>{`{Coeff STUD}`}</strong>
        </li>
        <li>
          Flexijobber: <strong>{`{Coeff FLEX}}`}</strong>
        </li>
      </ul>

      <p>
        De tarieven blijven geldig tot 31 december 2025 en voor zover er zich geen wijzigingen voordoen in de
        kostprijsopbouw eigen aan het paritair comité van toepassing bij
        <strong>{`  {BedrijfsnaamBedrijfsnaam}`}</strong> of eigen aan uitzendarbeid. Eventuele wijzigingen zullen
        steeds voorafgaandelijk met de gebruiker besproken worden.
      </p>

      <p>Inbegrepen:</p>
      <ul>
        <li>Brutoloon van de uitzendkracht</li>
        <li>Patronale bijdragen</li>
        <li>Sociale documenten</li>
        <li>Kosten van het vakantiegeld</li>
        <li>Eindejaarspremie</li>
        <li>Alle verplichte verzekeringspremies oa verzekering tegen arbeidsongevallen</li>
        <li>Opvolging en begeleiding van de uitzendkracht</li>
        <li>7/7 Bereikbaarheid: admin@update-pro.be</li>
        <li>On-line</li>
      </ul>

      <p>Niet-inbegrepen:</p>
      <ul>
        <li>Indirecte uren worden doorgefactureerd aan contractcoëfficiënt</li>
        <li>Sociaal abonnement: wettelijk barema x 1.25</li>
        <li>Aangifte dimona aan € 0.390 per aangegeven uur uitzendarbeid:</li>
        <li>Maaltijd- en/of ecocheques: werkgeversbijdrage x 1.69</li>
        <li>Bonus cao 90bis: bonus x 1.69 (indien van toepassing binnen uw onderneming of uw PC)</li>
        <li>Medisch onderzoek (indien vereist volgens werkpostfiche)</li>
        <li>
          Netto-bijdragen en/of vergoedingen die van toepassing zijn binnen de onderneming: netto- premie x 1.25 vb
          mobiliteitsvergoeding, arab-vergoeding, ….
        </li>
        <li>
          Bruto-bijdragen en/of vergoedingen die van toepassing zijn binnen de onderneming: bruto- premie x
          contractcoëfficiënt vb ploegenpremies, prestatiepremie,…
        </li>
        <li>Dossierskost Arbeidsongeval: € 150</li>
      </ul>

      <h3>2.2 Dimona</h3>
      <p>
        De gebruiker erkent het wettelijk belang van de onmiddellijke aangifte aan de RSZ. Dat houdt in dat de gebruiker
        Update-pro tijdig verwittigt bij het opstarten van een uitzendkracht zodat Update-pro de wettelijke
        verplichtingen tijdig kan vervullen. Bij gebrek aan een tijdige aanmelding draagt de gebruiker de
        verantwoordelijkheid voor de tewerkstelling van de uitzendkracht.
      </p>

      <h3>2.3 Tijdelijke werkloosheid</h3>
      <p>
        Mocht het bedrijf van de gebruiker verkeren in een situatie van tijdelijke werkloosheid, engageert de gebruiker
        er zich toe Update-pro de dag zelf te verwittigen of afhankelijk van de aard van de tijdelijke werkloosheid de
        na te leven termijn zodat zij indien nodig de meldingsplicht naar de RVA toe kan uitvoeren. Bij gebrek aan een
        tijdige melding verbindt de gebruiker er zich toe het verschuldigde loon van de betrokken uitzendkracht(en) te
        vergoeden.
      </p>

      <h3>2.4 Aansprakelijkheid</h3>
      <p>
        De gebruiker is aansprakelijk voor het bezorgen van alle informatie aan Update-pro die betrekking op de
        arbeidsduur, de feestdagen, de zondagsrust, de vrouwenarbeid, de moederschapsbescherming, de bescherming van
        moeders die borstvoeding geven, de arbeid van jeugdige personen, de nachtarbeid, de arbeidsreglementen, de
        bepalingen inzake het toezicht op de prestaties van de deeltijdse werknemers, de gezondheid en de veiligheid van
        de werknemers, en het welbevinden van het werk en van de werkplaatsen.
      </p>
      <p>
        Daarnaast is de gebruiker als enige verantwoordelijk voor de ingave van alle vereiste, correcte informatie voor
        de terbeschikking van de uitzendkracht(en) in het systeem waarvoor de gebruiker een beveiligde toegang heeft.
      </p>

      <h3>2.5 Verwerking persoonsgegevens</h3>
      <p>
        Beide partijen treden in het kader van de GDPR-wetgeving op als afzonderlijke verwerkingsverantwoordelijken. Dit
        betekent dat er geen aparte verwerkersovereenkomst dient te worden afgesloten.
      </p>
      <p>
        Dit betekent dat zowel het uitzendkantoor als de gebruiker ervoor moeten zorgen dat aan alle verplichtingen van
        de GDPR wordt voldaan en ieder hierin zijn eigen verantwoordelijkheid draagt.
      </p>

      <h3>2.6 Wijzigingen en nietigheid clausules</h3>
      <p>
        Elke wijziging van een of andere bepaling van dit contract en/of de algemene voorwaarden of eventuele andere
        bijlagen, zal het voorwerp uitmaken van een aanhangsel met het oog op de eerbiediging van de wettelijke
        beschikkingen.
      </p>
      <p>
        Indien enige bepaling van onderhavige overeenkomst nietig is, zullen de overige bepalingen volledig van kracht
        blijven en zullen de beide partijen de nietige bepaling vervangen door een andere bepaling die het doel en de
        strekking van de nietige bepaling zoveel mogelijk benadert.
      </p>

      <h3>2.7 Betalingsvoorwaarden</h3>
      <p>
        De betalingstermijn bedraagt 7 dagen na factuurdatum en wordt geïnd via domiciliëring. Alle vermelde bedragen
        zijn exclusief BTW 21%.
      </p>
      <p>Dit samenwerkingsvoorstel is geldig tot …….</p>

      <h3>3. Algemene voorwaarden</h3>
      <p>
        De kennis en aanvaarding van de algemene voorwaarden volgt expliciet uit de ondertekening van onderhavige
        overeenkomst. De algemene voorwaarden van Update-pro maken integrerend deel uit van deze overeenkomst en zijn
        als bijlage toegevoegd met nummer 1.
      </p>

      <p>
        Hierbij ondertekenen de partijen, vertegenwoordigd door hun wettelijke vertegenwoordigers, te Antwerpen op
        ........................................................ .
      </p>
      <p>
        in zoveel exemplaren als er partijen zijn, waarbij elke partij verklaart een ondertekend exemplaar te hebben
        ontvangen.
      </p>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ width: '50%', display: 'flex', flexDirection: 'column' }}>
          <div>Voor akkoord</div>
          <div>Dominique Matheussen</div>
          <div>
            <strong>Update-pro</strong>
          </div>
        </div>
        <div style={{ width: '50%', display: 'flex', flexDirection: 'column' }}>
          <div>Voor akkoord</div>
          <div>de gebruiker</div>
          <div>
            <strong>Bedrijfsnaam</strong>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CollaborationAgreementTemplate;
